<template>
<div class="bottom">
<loading :active='isLoading' :is-full-page="fullPage" :loader="loader" />
<div v-if="!bookSlotBoolean && !roomBoolean">
    
<div v-if="!emptycart" class="CartWeb">
    
<div class="row ">
    <div class="col-md-12">
        <span v-if="!viewcart" @click="backToStore()"><i class="fas fa-arrow-left mr-2"></i></span>
        <span class="heading-font-size2">Cart</span>
        <span class="cart-empty float-right"><span class="top-cart-item-count">{{itemsCount}}</span> ITEM</span>
        <hr class="mt-2"/>
    </div>

   <!-- <div class="row ml-3 home-slider mt-2 homepage-for-desktop"  v-for="item in items" :key="item.id">
    <div class="col-md-12 slider-btn-home p-1">
        <div id="app">
            <ul class="slider-btn-group pl-0 mb-0">
                <li v-if="item[0].JSon0[0].HomeDelivery == 'Y'" class="slider-btn orderType" id="home1" @click="selectDeliveryType('home1')">{{item[0].JSon0[0].LblDelivery}}</li>
                <li v-if="item[0].JSon0[0].Pickup == 'Y'" class="slider-btn" id="takeAway1" @click="selectDeliveryType('takeAway1')">{{item[0].JSon0[0].LblPickup}}</li>
                <li v-if="item[0].JSon0[0].InStorePurchase == 'Y'" class="slider-btn" id="dineIn1" @click="selectDeliveryType('dineIn1')">{{item[0].JSon0[0].LblInStore}}</li>
            </ul>
        </div>
    </div>
</div> -->


 <!-- <div class="col-md-12 pr-0" v-for="item in items" :key="item.id">
        <form action="" id="searchTypeToggle" class="slider-btn-index mt-2">
            <div></div>
            <label class="selected" v-if="item[0].JSon0[0].HomeDelivery == 'Y'" id="home1" @click="selectDeliveryType('home1')">
                    <input type="radio" name="searchtype" data-location="0" value="one">
                    <div>{{item[0].JSon0[0].LblDelivery}}</div>
            </label>
            <label class="" v-if="item[0].JSon0[0].Pickup == 'Y'" id="takeAway1" @click="selectDeliveryType('takeAway1')">
                    <input type="radio" name="searchtype" data-location="calc(100% - 5px)" value="two">
                    <div>{{item[0].JSon0[0].LblPickup}}</div>
            </label>
            <label v-if="item[0].JSon0[0].InStorePurchase == 'Y'" id="dineIn1" @click="selectDeliveryType('dineIn1')">
                    <input type="radio" name="searchtype" data-location="calc(200% - 12px)" value="three">
                    <div>{{item[0].JSon0[0].LblInStore}}</div>
            </label>
        </form>
</div> -->

</div>
<!-- eslint-disable -->
<div class=" homepage-for-desktop row mt-2 pt-1 pb-1 set-deliver d-flex" v-for="item in items" :key="item.id" v-if="showDeliverySchedule && item[0].JSon0[0].ScheduledDelivery == 'Y'" data-toggle="modal" data-target="#DeliveryTimeCart">
    <div class="col-lg-2 col-md-2 col-2 custom-text-color text-center align-self-center">
        <i class="far fa-clock align-middle"></i>
    </div>
    <div class="col-lg-8 col-md-8 col-8 delivery-time align-self-center p-0">
        <p class="mb-0 align-middle">{{deliveryStatement}}</p>
        <span id="cartSchedule">{{deliveryDate}}, {{deliveryTime}}</span>
    </div>
    <div class="col-lg-2 col-md-2 col-2 custom-text-color text-center align-self-center ">
        <i class="fas fa-angle-right"></i>
    </div>
</div>


<div class="row mt-4" v-for="item in ItemSelectedList" :key="item.id" v-if="item.quantity != null">

    <div class="col-8" v-if="item.quantity != 0">
        <span class="cProductheadingcart">{{item.name | nameLength}}</span>
        <div class="cProductsizecart" v-if="item.variant != 0 && easyCommerce">{{item.variant}}</div>
        <div class="cProductsizecart"><span v-if="item.variant != 0 && !easyCommerce" v-for="singleVariant,index in item.variant">{{singleVariant}}</span></div>
        <div class="cProductamountcart" ><b>{{currencyText}}{{item.cost}}</b></div>
        <a v-if="item.VID == ''" class="cProductamountcart"><b>{{item.timeStatement}}</b></a>
        <a v-if="item.VID == ''" class="text-danger float-right cCursorhover" @click="bookSlot(item.name)"><small>Change</small></a>
        <!-- <div ><b>{{item.quantity}}</b></div> -->

        
        <div v-if="item.VID == ''" class="cProductheadingcart mt-4">Service Location</div>
        <div v-if="item.VID == ''" class="cProductsizecart" ><span>{{item.location}}</span></div>
    </div>
<!-- eslint-enable -->

    <div class="col-4 col-md-4 col-lg-4 quantity-btn text-right" > 
        <div class="btn-group" v-if="item.typeOfProduct == 'store'">  
            <button class="qantity-decrement btn btn-sm custom-quantity-btn operator-btn text-white border-0" @click="add(item.name,item.cost,item)">+</button>
            <input class="product-quantity custom-quantity-btn count-quantity text-white quantity border-0 text-center" v-bind:id="item.name" type="number" name="quantity" min="1" max="10" v-bind:value="item.quantity" readonly/>
            <button class="quantity-increment btn btn-sm custom-quantity-btn operator-btn text-white border-0" @click="minus(item.name,item.cost,item)">-</button>
        </div>

        <div v-if="item.typeOfProduct != 'store'">
            <buttton  name="add" v-bind:id="item.name"  @click="minus(item.name,item.cost,item)" class="btn btn-sm float-right pl-1"><span class="add-button add-list-view cCursorhover">REMOVE</span></buttton>
        </div>
    </div>
    <div class="col-md-12">
        <hr/>
    </div>
</div>



<div class="row" v-if="!instructionBoolean">
    <div class="col-md-12 add-items toggle">
        <span class="toggle" >Order Instructions</span>
        <button data-toggle="modal" data-target="#addMoreItemsToCart" class="btn float-right"><i  class="fas fa-pencil-alt mr-2"></i>Edit</button>
    </div>
   
    <div class="col-md-12">
        <small>{{instruction}}</small>
        <hr/>
    </div>
</div>

 <div class="row" v-if="instructionBoolean">
                                <div class="col-md-8 col-8">
                                    <small class="add-any-instruction">Add order instructions?</small>
                                </div>
                                <div class="col-md-4 col-4 add-now">
                                    <a data-toggle="modal" data-target="#addMoreItemsToCart">Add Now
                                        <i class="fas fa-plus-circle"></i>
                                    </a>
                                    
                                </div>
                                <div class="col-md-12">
                                    <hr/>
                                </div>
                            </div>

<!-- page eight(8) end -->


<!-- Modal -->
<div class="modal fade modal-add" id="addMoreItemsToCart" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title product-heading-modal" id="exampleModalLongTitle">Add Order Instructions</h6>
        <button type="button" class="close add-more"  data-dismiss="modal" aria-label="Close">
          <i class="fas fa-times-circle"></i>
        </button>
      </div>
      <div class="modal-body">
        <form>
          <textarea rows="6" placeholder="Add Instruction" id="instructionBox" v-bind:value="instruction" class="form-control p-2" maxlength="50"></textarea>
          <input data-dismiss="modal" @click="addInstructions()" class="btn btn-lg btn-block modal-submit mt-2" value="SAVE">
        </form>
      </div>
    </div>
  </div>
</div>

<div class="row">

    <div class="col-md-8">
        <small>
        <p  class="mb-0">Subtotal</p>
        <p class="cExtracharges">Extra charges may apply</p>
        </small>
    </div>

    <div class="col-md-4">
        <span  class="float-right cCarttotalamt">
        <b >{{currencyText}}{{totalCount | total}}</b>
        </span>
    </div>


    <div class="col-md-12 text-center mt-3" @click="proceedToDetails()">
        <div class="checkout">
            <a ><span style="color:#fff">PROCEED <i class="fas fa-long-arrow-alt-right ml-3"></i></span></a>
        </div>
    </div>
</div>

</div>

<div v-if="emptycart" class="CartWeb">
<EmptyCart />
</div>
<!-- 
<div class="row fixed-bottom mobile-view-cart-bg p-2" v-if="viewcart && ItemSelectedList.length!=0">
        <div class="col border-right">
          <i class="fas fa-shopping-bag"></i> <span class="ml-2">{{itemsCount}} Items</span> <span class="float-right">{{currencyText}}{{totalCount | total}}</span>
        </div>
        <div class="col text-right">
          <a @click="routetoCart()">View Cart<i class="fas fa-chevron-right ml-2"></i></a>
        </div>
      </div>
</div> -->

<div class="row" v-if="viewcart && ItemSelectedList.length!=0">
      <div class="col-md-12 bottom-add-cart fixed-bottom p-2">
        <div class="row pl-1 pt-1">
          <div class="col-6">
            <div class="row text-white border-right">
              <div class="col-7 pr-0">
                <span><i class="fas fa-shopping-bag pr-2"></i> {{itemsCount}} item</span>
              </div>
              <div class="col-5 text-right">
                <span>{{currencyText}}{{totalCount | total}}</span>
              </div>
            </div>
          </div>
          <div class="col-6 text-white text-right">
            <a  @click="routetoCart()" class="text-white"><span>View Cart <i class="fas fa-angle-right pl-2"></i></span></a>
          </div>
        </div>
      </div>
    </div>
</div>

<div class="modal fade login show" id="DeliveryTimeCart" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header pl-4">
                <h5 class="modal-title" id="exampleModalLabel">Schedule Delivery</h5>
                <button type="button" class="close" id="closeDeliveryCart" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true"><img src="../assets/img/Icon material-cancel.svg" class="img-fluid"></span>
                </button>
            </div>

            <div class="modal-body">
                <div class="col-md-12">
                    <div class="row">
                        <div class="col-12 mb-2">
                            <button type="button" data-dismiss="modal" class="btn btn-block cModalbtnenable">Process Immediately</button>
                        </div>
                        <div class="col-12" data-toggle="modal" data-target="#scheduleForLaterCart" @click="ScheduleDelivery()">
                            <button type="button" class="btn btn-block cModalbtndisable">Schedule For Later</button>
                        </div>
                    </div>
                </div>

                <div class="col-md-12 text-center mt-4">
                    <p>Your order will be processed ASAP (As soon as possible).</p>
                    <img src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti/images/schedule.png" alt="">
                </div>
            </div>

        </div>
    </div>
</div>

<div class="modal fade login show" id="scheduleForLaterCart" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header pl-4">
                <h5 class="modal-title" id="exampleModalLabel">{{deliveryStatement}}</h5>
                <button type="button" class="close" id="closeScheduleLaterModel" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true"><img src="../assets/img/Icon material-cancel.svg" class="img-fluid"></span>
                </button>
            </div>


            <div class="modal-body">
                <div class="col-md-12">
                    <div class="row">
                        <div class="col-12 mb-2" @click="BackToImmediate()">
                            
                        <button  data-toggle="modal" data-target="#DeliveryTime" type="button" class="btn btn-block cModalbtndisable">Process Immediately</button>
                        </div>
                        <div class="col-12">
                            <button type="button" class="btn btn-block cModalbtnenable">Schedule For Later</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-body pr-4 pl-4 pb-4">
                <div class="col-md-12">
                    <form>
                        <div class="row">
                            <div class="col-6">
                                <div class="form-group">
                                    <label class="col-form-label"><small><b>Select Delivery Date</b></small></label>
                                    <div class="input-group-prepend custom-text-color">
                                        <div
                                            class="input-group-text date-time-background border-radius-date prepend-padding-right border-right-0">
                                            <i class="far fa-calendar-alt"></i></div>
                                        <input type="date" v-on:change="Datepicker($event)" v-bind:min="today"
                                            class="form-control date-time-background border-radius-text border-left-0"
                                            name="datepicker" value="" />

                                    </div>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="form-group">
                                    <label class="col-form-label"><small><b>Select Delivery time</b></small></label>
                                    <div class="input-group-prepend custom-text-color">
                                        <div
                                            class="input-group-text date-time-background border-radius-date border-right-0">
                                            <i class="far fa-clock"></i></div>
                                        <input type="time" v-on:change="Timepicker($event)"
                                            class="form-control date-time-background border-radius-text border-left-0"
                                            name="timepicker" value="09:00" />
                                        <div class="input-group-append">
                                            <span
                                                class="input-group-text date-time-background border-radius-forword border-left-0"><i
                                                    class="fas fa-chevron-right"></i></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            <div class="col-md-12">

                <button data-dismiss="modal" type="button" @click="confirmDeliveryTime()" class="btn btn-block pay-btn mb-4">Confirm Delivery Time</button>
            </div>

        </div>
    </div>
</div>

        <div class="col-md-12 for-desktop" v-if="bookSlotBoolean">
                    <div class="row mt-3">
                        <div class="col-md-12">
                            <p class="dr-day">Details</p>
                            <span class="datail-time">Time</span>
                            <p class="mb-0 full-time">16th September, Wednesday at 1pm</p>
                        </div>
                        <div class="col-md-12">
                            <form>
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                                    <label class="form-check-label patient-label ml-2" for="inlineCheckbox1">I’m the patient</label>
                                </div>
                                <div class="row">
                                    <div class="col-md-12 mt-2">
                                        <label class="label-name">Patient Name</label>
                                        <input type="text" class="form-control border-0 input-background" name="patientName" />
                                    </div>
                                    <div class="col-md-12 mt-2">
                                        <label class="label-name">Contact Person</label>
                                        <input type="text" class="form-control border-0 input-background" name="Contact" />
                                    </div>
                                    <div class="col-md-12 mt-2">
                                        <label class="label-name">Enter Your Contact  Number</label>
                                        <input type="number" class="form-control border-0 input-background" name="Contact" />
                                    </div>
                                    <div class="col-md-12 mt-2">
                                        <label class="label-name">Enter Your Email Address</label>
                                        <input type="email" class="form-control border-0 input-background" name="Email" />
                                    </div>
                                    <p class="booking-details m-3 mb-0">By Booking this appointment you agree to our <span class="terms">Terms & Conditions</span></p>
                                    <div class="col-md-12 mt-2">
                                        <a href="#" class="btn btn-block payment-btn text-white">Make Payment To Confirm Your Appointment</a>
                                    </div>
                                    <p class="mb-0 additional-detail m-3">Additional details can be added after successful payment.</p>
                                </div>
                            </form>
                        </div>
                    </div>
                
                </div>

    <div class="col-md-12 pt-3" v-if="roomBoolean">
                    <p class="font20 font500">Details </p>  
                    <div class="row font16">
                        <div class="col-6 col-md-12">
                            <p class="colorLightGray mb-0">Check In</p>
                            <p>After 2:00 PM</p>
                        </div>
                        <div class="col-6 col-md-12">
                            <p class="colorLightGray mb-0">Check Out</p>
                            <p>Before 12:00 PM</p>
                        </div>
                        <div class="col-12 col-md-12">
                            <p class="colorLightGray mb-0">Date</p>
                            <p>24th Aug 2021 - 25th Aug 2021</p>
                        </div>
                    </div> 
                </div>

</div>
</template>

<script>
import axios from 'axios';
import EmptyCart from './EmptyCart'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
export default{
    name: 'App',
    components:{
        EmptyCart,
        Loading
    },
    filters :{
         total : function(number){
            return number.toFixed(2)
        },
        nameLength: function(string){
            if(string.length > 25){
                return string.substring(0,25) + '...'
            }
            return string
        },
        product: function(string){
            return string + "product"
        }
    },
     data : function() {
      return {
          ItemSelectedList : [],
          itemsCount : 0,
          totalCount : 0,
          instruction : '',
          instructionBoolean : true,
          emptycart : true,
          addExtraItem : true,
          viewcart : true,
          count : 0,
          homeDeliveryActive:true,
          takeAwayActive : false,
          bookSlotBoolean: false,
          productDetail : null,
          variantList : [],
          currencyText:'',
          isLoading: false,
          fullPage: true,
          loader:'Spinner',
          flexiItemsList : [],
          deliveryTypeList : ['home1','takeAway1','dineIn1'],
          easyCommerce : false,
          tempDeliveryDate : 'Today',
          tempdeliveryTime : 'ASAP',
          deliveryDate : 'Today',
          deliveryTime : 'ASAP',
          showDeliverySchedule : true,
          deliveryStatement : 'SET DELIVERY TIME',
          deliveryMode : 'D',
          variantId : '',
          today : '',
          roomBoolean : false
      }
  },
  computed:{    
      items() {
        return this.$store.state.items
      }
    },
    
    mounted() {
     sessionStorage.setItem('DeliveryType','home1')
     sessionStorage.setItem('DeliveryDetails',JSON.stringify(({'deliveryDate':'Today','deliveryTime':'ASAP'})))
     this.today = new Date().toISOString().split('T')[0]

     if(sessionStorage.getItem('ECommDS') == 'EASYCOMM1' || sessionStorage.getItem('ECommDS') == 'easycomm1'){
                        this.easyCommerce = true
    }
    else if(sessionStorage.getItem('ECommDS') == 'ECOMM2' || sessionStorage.getItem('ECommDS') == 'ecomm2'){
                        this.easyCommerce = false
    }

    if(sessionStorage.getItem(this.$route.params.handle + ' Instruction') != null){
        this.instruction = sessionStorage.getItem(this.$route.params.handle + ' Instruction')
        this.instructionBoolean = false;
    }
    else{
        this.instruction = '';
        this.instructionBoolean = true

    }
    

        if(sessionStorage.getItem(this.$route.params.handle) != null){
                if(this.ItemSelectedList.length == 0){
            this.ItemSelectedList = JSON.parse(sessionStorage.getItem(this.$route.params.handle))
            this.emptycart = false;
            this.itemsCount = this.ItemSelectedList.length
            for(var j=0;j<this.ItemSelectedList.length;j++){
            this.totalCount = this.totalCount + (this.ItemSelectedList[j].cost*this.ItemSelectedList[j].quantity)
            }
        }
        }
        this.$root.$on('Services',() =>{
                this.roomBoolean = false;

        })
        this.$root.$on('Rooms',() =>{
                this.roomBoolean = true;
    
        })

        this.$root.$on('Store',() =>{
            this.roomBoolean = false;
        })

        this.$root.$on('Packages',() =>{
            this.roomBoolean = false;
        })

        this.$root.$on('clearSession',() =>{
            console.log("dihdwidwdh")
                this.emptycart = true;
                this.ItemSelectedList = []
            })   

        this.$root.$on('ItemSelected',(text) =>{
            console.log(text)
            if(text.length == 0){
                if(this.ItemSelectedList.length == 0){
                this.emptycart = true;
                return
                } 
            }

            if(this.currencyText == ''){
                this.currencyText = text[0].currency
                console.log(text)
            }

            for(var i=0;i<text.length;i++){
                if(!this.ItemSelectedList.some(data => data.productHandle === text[i].productHandle && data.variant === text[i].variant)){
                    this.ItemSelectedList.push(text[i])
                }
                else if(this.ItemSelectedList.some(data => data.name === text[i].name && data.variant === text[i].variant && text[i].quantity == 0)){
                    var index = this.ItemSelectedList.indexOf(text[i]);
                    this.ItemSelectedList.splice(index,1);
                    this.itemsCount = this.ItemSelectedList.length
                    sessionStorage.setItem(this.$route.params.handle,JSON.stringify(this.ItemSelectedList))
                }
                 else if(this.ItemSelectedList.some(data => data.name === text[i].name && data.variant === text[i].variant && text[i].quantity != data.quantity)){
                    this.ItemSelectedList = []
                    this.ItemSelectedList = text
                }
            }

            sessionStorage.setItem(this.$route.params.handle,JSON.stringify(this.ItemSelectedList))

            this.itemsCount = this.ItemSelectedList.length
            this.totalCount=0;
            for(var j=0;j<this.ItemSelectedList.length;j++){
                this.totalCount = this.totalCount + (this.ItemSelectedList[j].cost*this.ItemSelectedList[j].quantity)
            }
            
            
            if(this.ItemSelectedList.length != 0){
                this.emptycart = false;
            }


        })
    },
   
    methods: {
        minus: function(text,cost,item) {
            console.log(item)
            if(document.getElementById(text).value != 0){
                item.quantity = item.quantity - 1;
                this.totalCount = this.totalCount - cost;
                sessionStorage.setItem(this.$route.params.handle,JSON.stringify(this.ItemSelectedList))
                 this.$root.$emit('cartListChanges',this.ItemSelectedList,item)
                if( item.quantity == 0){
                   
                    var index = this.ItemSelectedList.indexOf(item);
                    this.ItemSelectedList.splice(index,1);
                    this.itemsCount = this.ItemSelectedList.length
                    if(this.itemsCount == 0){
                        sessionStorage.removeItem(this.$route.params.handle)
                    }
                    else{
                         sessionStorage.setItem(this.$route.params.handle,JSON.stringify(this.ItemSelectedList))
                    }
                    this.$root.$emit('cartListChanges',this.ItemSelectedList,item)

                }
                if(this.ItemSelectedList.length == 0){
                    this.emptycart = true
                }
               
            }
            
        },
         add: function(value,cost,item) {
            
                item.quantity = item.quantity + 1;
                this.totalCount = this.totalCount + cost
                this.$root.$emit('cartListChanges',this.ItemSelectedList,item)
                sessionStorage.setItem(this.$route.params.handle,JSON.stringify(this.ItemSelectedList))
            
            
        },
           BackToImmediate: function(){
            var closeDeliveryComp = document.getElementById("closeScheduleLaterModel")
            closeDeliveryComp.click()
        },

        addInstructions: function(){
            this.instruction = document.getElementById('instructionBox').value
            if(this.instruction != ''){
                this.instructionBoolean = false
            }
           sessionStorage.setItem(this.$route.params.handle + ' Instruction',this.instruction)
        },
        bookSlot: function(name){
            this.$root.$emit('slotBooking',true,name)
        },
        routetoCart: function(){
            this.viewcart= false
            document.getElementById('categoryHeader').style.display = 'none';
            document.getElementById('mainHeader').style.display = 'none';
            document.getElementsByClassName('CartWeb')[0].style.display = 'block';
        },
        backToStore: function(){
            this.viewcart= true
            document.getElementById('categoryHeader').style.display = 'block';
            document.getElementById('mainHeader').style.display = 'block';
            document.getElementsByClassName('CartWeb')[0].style.display = 'none';
        },
        selectDeliveryType: function(deliveryType){
            if(deliveryType == 'dineIn1'){
                this.showDeliverySchedule = false;
            }
            else{
                this.showDeliverySchedule = true;
            }
            if(deliveryType == 'takeAway1'){
                this.deliveryStatement = 'SET TAKE-OUT TIME';
            }
            else{
                this.deliveryStatement = 'SET DELIVERY TIME';
            }
            
            document.getElementById(deliveryType).classList.add('orderType')
            sessionStorage.setItem('DeliveryType',deliveryType)
            for(var i=0;i<this.deliveryTypeList.length;i++){
                if(this.deliveryTypeList[i] != deliveryType){
                    document.getElementById(this.deliveryTypeList[i]).classList.remove('orderType')
                }
            }
        },
        maketkActive: function(){
            this.takeAwayActive = true
            this.homeDeliveryActive = false
        },
        makeActive: function(){
            this.takeAwayActive = false
            this.homeDeliveryActive = true
        },
        variantDetails: function(variant,product){
            document.getElementById(product.ProductName).innerHTML=this.currencyText + variant.OfferPrice
            document.getElementById(product.ProductHandle).innerHTML=this.currencyText + variant.MRP
            document.getElementById(variant.ProductVariantID).classList.add('active')
            for(var i=0;i<this.variantList.length;i++){
                if(this.variantList[i].ProductHandle == product.ProductHandle && this.variantList[i].ProductVariantID != variant.ProductVariantID){
                    document.getElementById(this.variantList[i].ProductVariantID).classList.remove('active')

                }
            }
            this.variantId = variant.ProductVariantID
        },
         Datepicker: function(event){
        console.log(event.target.value)
        this.tempDeliveryDate = event.target.value
        },
        Timepicker: function(event){
            this.tempdeliveryTime = event.target.value
        },
        confirmDeliveryTime: function(){
            this.deliveryDate = this.tempDeliveryDate;
            this.deliveryTime = this.tempdeliveryTime;

            sessionStorage.setItem('DeliveryDetails',JSON.stringify(({'deliveryDate':this.deliveryDate,'deliveryTime':this.deliveryTime})))
        },
        ScheduleDelivery: function(){
            var closeDeliveryComp = document.getElementById("closeDeliveryCart")
            closeDeliveryComp.click()
        },
        proceedToDetails: function(){
            if(localStorage.getItem('LoginToken') == null){
                this.$root.$emit('openLoginModal')
            }
            else{
                this.checkout();
            }
           
        },
        checkout: function(){
            // this.$router.push({path:this.$route.params.handle+'/checkout'})
            this.isLoading = true;
            const uniqueId = this.$route.params.handle.substring(0,16) + "-" + Math.random().toString(36).slice(2)
            const batchHandle = new Date().getTime()
            const submitItemsList = [];
            const serviceList = [];
            const packageList = [];
            var sno = 1;
            console.log(uniqueId)
            if(!this.easyCommerce){
                for(var i=0;i<this.ItemSelectedList.length;i++){
                if(this.ItemSelectedList[i].typeOfProduct == 'store'){
                    submitItemsList.push({SN:sno,BH:this.ItemSelectedList[i].BH,PH:this.ItemSelectedList[i].productHandle,PLID:this.ItemSelectedList[i].PLID,Q:this.ItemSelectedList[i].quantity,Variants:this.ItemSelectedList[i].variantList})
                    sno = sno + 1;
                    console.log(submitItemsList)
                }
            }
            }
            else{  
                for(var j=0;j<this.ItemSelectedList.length;j++){
                if(this.ItemSelectedList[j].typeOfProduct == 'store'){
                    submitItemsList.push({SN:sno,BH:this.ItemSelectedList[j].BH,PH:this.ItemSelectedList[j].productHandle,PLID:this.ItemSelectedList[j].PLID,Q:this.ItemSelectedList[j].quantity})
                    sno = sno + 1;
                    console.log(submitItemsList)
                }
            }
            }

            var sn = 1;
            for(var k=0;k<this.ItemSelectedList.length;k++){
                if(this.ItemSelectedList[k].typeOfProduct == 'service'){
                    serviceList.push({SN:sn,SH:this.ItemSelectedList[k].productHandle,Q:this.ItemSelectedList[k].quantity,"SD": "13/09/2021","ST": "13:50","AddOn":[],"SPL":"","REM":"","LOC":"B"})
                    sno = sn + 1;
                    console.log(serviceList)
                }
            }

            var packno = 1;
            for(var z=0;z<this.ItemSelectedList.length;z++){
                if(this.ItemSelectedList[z].typeOfProduct == 'package'){
                    packageList.push({SN:packno,PH:this.ItemSelectedList[z].productHandle,Q:this.ItemSelectedList[z].quantity,"SD": "13/09/2021","ST": "13:50","SPL":"","AOS":"","LOC":"B"})
                    sno = packno + 1;
                    console.log(packageList)
                }
            }


           let items = [
            {
                "CartSummary": [
        {
          "StoreHandle": sessionStorage.getItem('storeHandle'),
          "BranchHandle": sessionStorage.getItem('StoreBranchHandle'),
          "CartHandle": uniqueId,
          "Channel": "O",
          "CitizenHandle": "",
          "AddressHandle": "",
          "BatchHandle": batchHandle,
          "Remarks": this.instruction,
          "DiscountCode": "",
          "DeliveryMode": "",
          "LanguageID": 100000,
          "Tip": 0,
          "DeliveryDate": null,
          "DeliveryTime": null,
          "BCompanyHandle": sessionStorage.getItem('companyHandle'),
          "BOutletHandle": sessionStorage.getItem('handle'),
          "BAmountPaid" : 100,
          "Beneficiary": [{
            "Name": "",
            "Mobile": '',
            "Email": "",
            "Age": ''
          }]
        }
      ],
      "CartItems": submitItemsList,
      "Services": serviceList,
      "Packages": packageList,
    "InstaVend": []
            }
        ]
        axios
                .post('https://entityserver.manikworks.com/cartmgr',
                {
                items
                },
                {
                    headers: {
                        'Authorization': 'Bearer ' + sessionStorage.getItem('Token'),
                        'EntityActionType': 'POST.CART',
                        'ECommDS': sessionStorage.getItem('ECommDS'),
                        'ECommPlan': 'A',
                        'BookingDS':'BOOKING2',
                        'BookingPlan':'A'
                    }
                })
                .then((response) =>{
                                    console.log(response)
                                    sessionStorage.setItem('submitCart',JSON.stringify(response.data.ManikJSon[0]))
                                    this.$router.push({name:'checkout'})
                                    this.isLoading = false
})
.catch(() =>{
                    this.isLoading = false;
                })
        }
    }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
